import { FormStructure } from '@europrocurement/flexy-form/components';
import { jsonDayMonthInput } from '../types/formTypes';

const jsonDayMonthInputToFormElement: (input: jsonDayMonthInput) => FormStructure = (input) => {
    const baseField: FormStructure = {
        type: input.type,
        name: input.name,
        inputlabel: input.inputlabel,
        dayplaceholder: input.dayplaceholder,
        monthplaceholder: input.monthplaceholder,
        xs: input.xs,
        sm: input.sm,
        md: input.md,
        lg: input.lg,
        sx: {
            fontSize: '14px',
            marginTop: '15px',
            marginBottom: '15px',
            fontWeight: '500',
        },
        tooltip: input.tooltip,
        defaultValue: input.defaultvalue,
    };

    // comportement sur rules display
    if (input.rules && input.rules.copyValueTo) {
        baseField.onChangeInput = (e, inputPath, formContextOnChangeInput) => {
            const fieldToCopyTo = input.rules.copyValueTo as string;
            formContextOnChangeInput.setValue(fieldToCopyTo, e);
        };
    }

    // comportement sur rules display
    if (input.rules && input.rules.display) {
        if (input.rules.display.fieldIsEqualTo) {
            const fieldNameToWatch = input.rules.display.fieldIsEqualTo.field;
            const valueToWatch = String(input.rules.display.fieldIsEqualTo.value);

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) => {
                const valueWatch: string = formContext.watch(fieldNameToWatch as string)?.value;

                return Array.isArray(valueToWatch)
                    ? valueToWatch.includes(valueWatch)
                    : valueWatch === valueToWatch;
            };
        }
    }

    return baseField;
};

export default jsonDayMonthInputToFormElement;
